import React, { useState } from "react";
import { useReveal } from "../components/Layout";
import { Mail, Phone, MapPin, ArrowUpRight, Check } from "lucide-react";

const Kontakt = () => {
  useReveal();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // Frontend-only: store to localStorage for demo
    const prev = JSON.parse(localStorage.getItem("animusz_messages") || "[]");
    prev.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem("animusz_messages", JSON.stringify(prev));
    setSent(true);
    setTimeout(() => { setSent(false); setForm({ name: "", email: "", subject: "", message: "" }); }, 3500);
  };

  return (
    <div className="pt-24">
      {/* HERO */}
      <section className="px-6 md:px-10 max-w-[1800px] mx-auto pt-8 pb-16">
        <div className="flex justify-between mono text-[11px] tracking-[0.25em] opacity-60 mb-16">
          <div>[ 04 — KONTAKT ]</div>
          <div>PIOTRKOWSKA 132 / ŁÓDŹ</div>
        </div>
        <h1 className="display text-[15vw] md:text-[12vw] leading-[0.85] rise-in">
          Napisz.
          <br />
          <span className="serif italic font-normal text-[#FF4D2E]">Zadzwoń.</span>
          <br />
          <span className="text-outline">Odwiedź.</span>
        </h1>
      </section>

      {/* CONTACT GRID */}
      <section className="px-6 md:px-10 max-w-[1800px] mx-auto">
        <div className="grid md:grid-cols-12 gap-8">
          {/* Info */}
          <div className="md:col-span-5 space-y-10">
            <div className="reveal">
              <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-4">[ FIRMA ]</div>
              <div className="display text-4xl md:text-5xl mb-2">Magdalena Parszewska</div>
              <div className="serif italic text-2xl text-[#FF4D2E]">Animusz Studio</div>
            </div>

            <div className="reveal border-t border-black/20 pt-8">
              <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-4 flex items-center gap-2"><MapPin size={12} /> ADRES</div>
              <p className="text-xl leading-tight">
                ul. Piotrkowska 132 lok. 5U<br />
                90-062 Łódź<br />
                Polska
              </p>
            </div>

            <div className="reveal border-t border-black/20 pt-8">
              <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-4 flex items-center gap-2"><Phone size={12} /> TELEFON</div>
              <a href="tel:+48796633631" className="display text-3xl md:text-4xl link-underline w-fit block">+48 796 633 631</a>
            </div>

            <div className="reveal border-t border-black/20 pt-8">
              <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-4 flex items-center gap-2"><Mail size={12} /> E-MAIL</div>
              <a href="mailto:animuszstudio@gmail.com" className="display text-3xl md:text-4xl link-underline w-fit block break-all">animuszstudio@gmail.com</a>
            </div>
          </div>

          {/* Form */}
          <div className="md:col-span-7">
            <div className="reveal bg-[#0E0E0E] text-[#F2EEE5] p-8 md:p-12">
              <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-3">[ NAPISZ DO NAS ]</div>
              <h2 className="display text-4xl md:text-5xl mb-8">Zaczynajmy.</h2>
              <form onSubmit={submit} className="space-y-6">
                <div>
                  <label className="mono text-[10px] tracking-widest opacity-60 block mb-2">01 / IMIĘ I NAZWISKO</label>
                  <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                    className="w-full bg-transparent border-b border-white/30 py-3 text-lg focus:outline-none focus:border-[#FF4D2E] transition-colors" />
                </div>
                <div>
                  <label className="mono text-[10px] tracking-widest opacity-60 block mb-2">02 / E-MAIL</label>
                  <input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                    className="w-full bg-transparent border-b border-white/30 py-3 text-lg focus:outline-none focus:border-[#FF4D2E] transition-colors" />
                </div>
                <div>
                  <label className="mono text-[10px] tracking-widest opacity-60 block mb-2">03 / TEMAT</label>
                  <input required value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })}
                    className="w-full bg-transparent border-b border-white/30 py-3 text-lg focus:outline-none focus:border-[#FF4D2E] transition-colors" />
                </div>
                <div>
                  <label className="mono text-[10px] tracking-widest opacity-60 block mb-2">04 / WIADOMOŚĆ</label>
                  <textarea required rows="4" value={form.message} onChange={e => setForm({ ...form, message: e.target.value })}
                    className="w-full bg-transparent border-b border-white/30 py-3 text-lg focus:outline-none focus:border-[#FF4D2E] transition-colors resize-none" />
                </div>
                <button type="submit" className="group inline-flex items-center gap-3 border border-[#F2EEE5] px-6 py-4 hover:bg-[#FF4D2E] hover:border-[#FF4D2E] transition-colors duration-300 mt-4">
                  {sent ? <><Check size={18} /> <span className="text-lg">Wysłano!</span></> : <><span className="text-lg">Wyślij wiadomość</span><ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform duration-500" /></>}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="px-6 md:px-10 max-w-[1800px] mx-auto pt-24">
        <div className="reveal mb-6">
          <div className="mono text-[11px] tracking-[0.3em] opacity-60 mb-4">[ ZNAJDŹ NAS ]</div>
          <h2 className="display text-4xl md:text-6xl">Fabryka Sztuki, Łódź.</h2>
        </div>
        <div className="reveal aspect-[16/8] w-full overflow-hidden border border-black/20">
          <iframe title="Animusz Studio Location"
            src="https://www.google.com/maps?q=Piotrkowska+132,+%C5%81%C3%B3d%C5%BA&output=embed"
            className="w-full h-full grayscale contrast-125" loading="lazy" />
        </div>
      </section>
    </div>
  );
};

export default Kontakt;
